"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionCategory = void 0;
class TransactionCategory {
    constructor(data) {
        if (data) {
            this.deserialize(data);
        }
    }
    deserialize(input) {
        Object.assign(this, input);
        this.id = input.id || input._id;
        return this;
    }
}
exports.TransactionCategory = TransactionCategory;
